import { render, staticRenderFns } from "./CCookieModal.vue?vue&type=template&id=776f3338&scoped=true&"
import script from "./CCookieModal.vue?vue&type=script&lang=ts&"
export * from "./CCookieModal.vue?vue&type=script&lang=ts&"
import style0 from "./CCookieModal.vue?vue&type=style&index=0&id=776f3338&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776f3338",
  null
  
)

export default component.exports